import React from 'react';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import { AuthProvider } from './AuthProvider';
import Root from './Root';
import MainHeader from './MainHeader/index';
import Menu from './HorizontalMenu/index';
import Calculator from './Calculator';
import SentBudgets from './SentBudgets';
import oidcConfig from '../utils/auth/oidcConfig';

class Routes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      budgetRouteRef: undefined,
      routeRef: undefined,
    };
  }
  shouldComponentUpdate(nextState) {
    if (this.routersRefAlreadySetted()) {
      return false;
    }
    return true;
  }
  routersRefAlreadySetted = () => {
    return (
      this.state.budgetRouteRef !== undefined &&
      this.state.routeRef !== undefined
    );
  };
  updateRouterCalculatorRef = (c) => {
    this.setState({ budgetRouteRef: c });
  };
  updateRouterRef = (c) => {
    this.setState({ routeRef: c });
  };

  render() {
    return (
      <AuthProvider {...oidcConfig}>
        <Root>
          {(agentId) => {
            return (
              <Router
                ref={(c) => {
                  this.updateRouterRef(c);
                }}
              >
                <div style={{ maxWidth: '1500px' }} className="outer-container">
                  <MainHeader routeRef={this.state.routeRef} />
                  <Menu
                    budgetRouteRef={this.state.budgetRouteRef}
                    agentId={agentId}
                  />
                  <Route
                    ref={(c) => {
                      this.updateRouterCalculatorRef(c);
                    }}
                    path="/presupuesto/:product"
                    render={(props) => (
                      <Calculator {...props} agentId={agentId} />
                    )}
                  />
                  <Route
                    path="/mis-presupuestos"
                    render={(props) => (
                      <SentBudgets {...props} agentId={agentId} />
                    )}
                  />
                  <Route
                    exact
                    path="/"
                    render={(props) => (
                      <Redirect
                        to={`/mis-presupuestos${props.location.search}`}
                      />
                    )}
                  />
                </div>
              </Router>
            );
          }}
        </Root>
      </AuthProvider>
    );
  }
}

export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routes.js